import React, { useState ,useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import {deleteTerminal} from '../../../../../../../../crud/management_api/terminals';
import { toast } from 'react-toastify';



const DeleteTerminal: React.FC<any> =  ({
        showDeleteModal,
        setShowDeleteModal,
        currentTerminal,
        currentData,
        setCurrentData
      }
      ) => {
        const [isDeleting, setIsDeleting] = useState(false);
        
        const handleDeleteTerminal = async () => {
          if (currentTerminal && !isDeleting) {
            setIsDeleting(true);
            try {
             const isSuccess = await deleteTerminal(Number(currentTerminal.terminal_id));
              if (isSuccess) {
                toast.success('Dispositivo eliminado con éxito!');
                  const updatedData = currentData.filter((terminal:any) => terminal.terminal_id !== currentTerminal.terminal_id);
                  setCurrentData(updatedData);
              } else {
                console.error('Error al eliminar el dispositivo');
                toast.error('Error al eliminar el dispositivo');
              }
            } catch (error) {
              console.error('Error al eliminar el dispositivo', error);
              toast.error('Error al eliminar el dispositivo');
            } finally {
              setIsDeleting(false);
            }
            setShowDeleteModal(false);
          }
        };
        return (
          <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header >
          <div className='form-modal-title-container'>
            <Modal.Title className='form-modal-title'>Confirmar eliminación</Modal.Title>
          </div>
            <Button variant="none" className="modal-close-button" onClick={() => setShowDeleteModal(false)}>
              <X size={24} /> 
            </Button>
          </Modal.Header>
          <Modal.Body>Estás seguro que quieres eliminar este dispositivo ?</Modal.Body>
          <Modal.Footer>
          <div className="form-modal-footer-custom">
            <Button 
              className="form-button-cancel" 
              onClick={() => setShowDeleteModal(false)}
              disabled={isDeleting}
            >
              Cancelar
            </Button>
            <Button 
              className="form-button-create" 
              onClick={handleDeleteTerminal}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Eliminando...
                </>
              ) : (
                'Eliminar'
              )}
            </Button>
          </div>
          </Modal.Footer>
        </Modal>
      )};

export default DeleteTerminal;